"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var Sonarlint = function Sonarlint(props) {
  var color = props.color,
      size = props.size,
      others = _objectWithoutPropertiesLoose(props, ["color", "size"]);

  return _react.default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 24 24"
  }, others), _react.default.createElement("path", {
    d: "M12.182.033c-.697-.01-1.399.008-1.787.063a12.054 12.054 0 00-6.88 3.414C1.226 5.8 0 8.754 0 12.004c0 3.298 1.26 6.283 3.611 8.568 1.833 1.779 3.991 2.871 6.53 3.293.79.127 2.731.144 3.527.024 2.647-.392 4.94-1.537 6.814-3.412 2.394-2.382 3.635-5.53 3.508-8.895-.12-3.135-1.295-5.842-3.502-8.055C18.673 1.72 16.514.603 13.94.145 13.57.08 12.878.043 12.182.033zm-.026 2.127c.38.007.764.033 1.15.082 2.129.272 4.113 1.255 5.663 2.805 1.88 1.881 2.875 4.286 2.875 6.951 0 2.647-.97 5.011-2.826 6.904-1.387 1.405-3.076 2.328-5.047 2.75-.863.187-2.538.229-3.407.096-2.164-.35-4.021-1.283-5.54-2.809-1.52-1.513-2.45-3.359-2.788-5.517-.096-.621-.096-2.28 0-2.865.38-2.255 1.292-4.02 2.871-5.577 1.92-1.888 4.39-2.867 7.05-2.82zm6.91 7.639c-.095-.023-.2-.013-.357.017-.253.049-.746.61-1.012 1.164-.452.929-.725 1.2-1.123 1.11-.277-.06-.705-.531-1.06-1.17-.38-.675-.447-.76-.743-.91-.602-.308-1.127 0-1.664.982-.373.67-.645.952-.964.994-.248.037-.27.024-.541-.26-.157-.162-.404-.523-.555-.8-.332-.621-.58-.815-1.05-.815-.833 0-1.177.254-1.665 1.23-.35.694-.645 1.085-.826 1.085-.296 0-.573-.324-1.043-1.235-.169-.331-.378-.675-.469-.765-.597-.633-1.7-.097-2.34 1.133-.138.265-.35.663-.47.886-.187.356-.217.47-.217.82 0 .495.085.645.332.585.235-.06.59-.452.957-1.06.506-.839 1.002-1.105 1.412-.755.205.175.41.573.5.983.084.41.441.855.797 1 .253.108.319.115.572.043.398-.103.778-.446 1.11-1.006.488-.82.916-1.093 1.453-.93.331.097.613.405.94 1.014.463.862.844 1.193 1.2 1.043.32-.139.627-.488.977-1.121.374-.682.742-.997 1.164-.997.422 0 .796.314 1.182.977.229.41.656.803.916.857.259.049.608-.055.837-.242.103-.09.34-.415.52-.722.856-1.454 1.404-1.4 2.314.222.217.386.586.7.748.639.109-.042.188-.507.133-.82-.054-.332-.777-1.893-1.115-2.387-.157-.23-.398-.507-.543-.615-.124-.097-.21-.152-.307-.174z"
  }));
};

Sonarlint.propTypes = {
  /**
   * Hex color or color name
   */
  color: _propTypes.default.string,

  /**
   * The size of the Icon.
   */
  size: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
Sonarlint.defaultProps = {
  color: 'currentColor',
  size: '24'
};
var _default = Sonarlint;
exports.default = _default;